angular.module('smartorg.r6.mgmts.groupManage', []);
require('./group-directive');
require('../../css/app.css');
module.exports = 'smartorg.r6.mgmts.groupManage';
//# sourceMappingURL=app.js.map


// WEBPACK FOOTER //
// ./app/widgets/management/group-manage/app/js/plumbing/app.js